// extracted by mini-css-extract-plugin
export default {"fileInput":"News_fileInput__yFY2Y"};